<template>
  <div>
    <s-crud @returnObject='refresh($event)'
      no-border
      :title="'Valores de definición: ' + this.defID"
      :config="this.config"
      @save="saveDed($event)"
      add
      @clearForm="clearForm()"
      edit
      restore
      remove
      :filter="filter"
      formPermanent
      noConfimationSave
      @removed="$emit('refresh', null)"
    > 
      <template v-slot:options>
        <v-btn small color="success" class="mx-1" @click="dialogUpload = true" :disabled="!defID">
          <v-icon left>mdi-file-excel</v-icon> Carga Masiva
        </v-btn>
      </template>
      <template scope="props">
        <v-container style="padding-top:0px;" v-if="props.item != null" class="pb-0">
          <v-row v-if="useCustomForm">
            <v-col
              v-for="(field, index) in normalizedCustomFields"
              :key="field.key"
              cols="12"
              md="6"
              class="s-col-form"
            >
              <s-text
                :ref="`Field_${field.key}`"
                :autofocus="index === 0"
                :disabled="isFieldDisabled(field, props.item)"
                v-model="props.item[field.key]"
                :label="field.labelWithRequired"
              />
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="10" class="s-col-form">
              <s-text autofocus ref="DedDescription" v-model="props.item.DedDescription" label="Descripción Detalle" />
            </v-col>
            <v-col cols="2" class="s-col-form">
              <s-text :disabled="props.item.DedID == 0" v-model="props.item.DedValue" label="Valor" />
            </v-col>
            <v-col cols="6" class="s-col-form">
              <s-text v-model="props.item.DedAbbreviation" label="Abreviatura" />
            </v-col>
            <v-col cols="6" class="s-col-form">
              <s-text v-model="props.item.DedHelper" label="Utilitario" />
            </v-col>
            <v-col cols="6" class="s-col-form">
              <s-text v-model="props.item.DedHelper2" label="Utilitario 2" />
            </v-col>
            <v-col cols="6" class="s-col-form">
              <s-text v-model="props.item.DedFormat" label="Formato" />
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:SecStatus="{ row }">
        <v-icon :color="row.SecStatus == 1 ? 'success' : 'default'"> mdi-checkbox-blank-circle</v-icon>
      </template>
    </s-crud>

    <!-- Dialogo de Carga Masiva de Excel -->
    <v-dialog v-model="dialogUpload" max-width="650" persistent>
      <v-card>
        <s-toolbar label="Carga Masiva de Detalles (Excel)" dark color="success" close @close="closeUploadDialog()" />
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-file-input
                label="Seleccione archivo Excel"
                accept=".xlsx,.xls"
                v-model="excelFile"
                outlined
                dense
                @change="onFileChange"
                hide-details
              />
            </v-col>
          </v-row>

          <v-card v-if="columns.length > 0" outlined class="pa-3 mt-4">
            <div class="subtitle-2 mb-3 font-weight-bold grey--text text--darken-2">Mapeo de Columnas del Excel:</div>
            <v-row dense>
              <v-col cols="6">
                <s-text type="number" label="Fila de Inicio (Row)" v-model="startRow" />
              </v-col>
              <v-col cols="6">
                <v-select
                  :items="columns"
                  label="Valor (DedValue)"
                  v-model="valCol"
                  clearable
                  hint="Opcional. Vacío para autogenerar."
                  persistent-hint
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="6" class="mt-2">
                <v-select
                  :items="columns"
                  label="Descripción *"
                  v-model="descCol"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="6" class="mt-2">
                <v-select
                  :items="columns"
                  label="Abreviatura"
                  v-model="abbrCol"
                  clearable
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="6" class="mt-2">
                <v-select
                  :items="columns"
                  label="Utilitario (Helper)"
                  v-model="helperCol"
                  clearable
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="6" class="mt-2">
                <v-select
                  :items="columns"
                  label="Utilitario 2 (Helper 2)"
                  v-model="helper2Col"
                  clearable
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" class="mt-2">
                <v-select
                  :items="columns"
                  label="Formato"
                  v-model="formatCol"
                  clearable
                  outlined
                  dense
                  hide-details
                />
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        <v-card-actions class="pb-4 px-6">
          <v-spacer />
          <v-btn color="error" text @click="closeUploadDialog">Cancelar</v-btn>
          <v-btn color="success" :loading="loadingUpload" :disabled="!excelFile || !descCol" @click="processUpload">
            <v-icon left>mdi-cloud-upload</v-icon> Procesar e Importar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _sDefinitionDetail from "@/services/General/DefinitionDetailService";
import ExcelJS from "exceljs";
export default {
  props: {
    defID: 0,
    defDescription: "",
    customAdd: {
      type: Boolean,
      default: false,
    },
    customFields: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    dialogUpload: false,
    excelFile: null,
    columns: [],
    startRow: 2,
    valCol: null,
    descCol: null,
    abbrCol: null,
    helperCol: null,
    helper2Col: null,
    formatCol: null,
    loadingUpload: false,
    defaultFieldLabels: {
      DedDescription: "Descripción Detalle",
      DedValue: "Valor",
      DedAbbreviation: "Abreviatura",
      DedHelper: "Utilitario",
      DedHelper2: "Utilitario 2",
      DedFormat: "Formato",
    },
    // filter: { DefID: 0, SecStatus: 0 },
    config: {
      title: "Definiciones Detalles",
      service: _sDefinitionDetail,
      model: {
        DedID: "ID",
        DefID: "int",
        DedDescription: "string",
        DedAbbreviation: "string",
        DedHelper: "string",
        DedValue: "int",
        SecStatus: "status",
      },
      headers: [
        {
          text: "ID",
          value: "DedID",
          width: "5%",
          align: "end",
          sorteable: true,
        },
        {
          text: "Definicion",
          value: "DedDescription",
          width: "55%",
          sorteable: true,
        },
        {
          text: "Abreviatura",
          value: "DedAbbreviation",
          width: "15%",
          sorteable: false,
        },
        {
          text: "Helper",
          value: "DedHelper",
          width: "15%",
          sorteable: false,
        },
        {
          text: "Helper2",
          value: "DedHelper2",
          width: "15%",
          sorteable: false,
        },
        {
          text: "Formato",
          value: "DedFormat",
           
          sorteable: false,
        },
        {
          text: "Valor",
          value: "DedValue",
          width: "5%",
          align: "center",
          sorteable: true,
        },
        {
          text: "Estado",
          value: "SecStatus",
          width: "5%",
          align: "center",
          sorteable: false,
        },
      ],
    },
  }),
  // watch: {
  //   defID() {
  //     this.filter = {
  //       DefID: this.defID,
  //       SecStatus: 0,
  //     };
  //   },
  // },
  computed: {
    useCustomForm() {
      return this.customAdd && this.normalizedCustomFields.length > 0;
    },
    normalizedCustomFields() {
      const fields = Array.isArray(this.customFields) ? this.customFields : [];

      return fields
        .map((field) => {
          if (typeof field === "string") {
            const label = this.defaultFieldLabels[field] || field;
            return {
              key: field,
              label,
              required: false,
              cols: 6,
              disableOnEdit: false,
              disableOnCreate: false,
              labelWithRequired: label,
            };
          }

          if (!field || typeof field !== "object" || !field.key) {
            return null;
          }

          const label = field.label || this.defaultFieldLabels[field.key] || field.key;
          const required = field.required === true;

          return {
            key: field.key,
            label,
            required,
            cols: Number(field.cols) > 0 ? Number(field.cols) : 6,
            disableOnEdit: field.disableOnEdit === true,
            disableOnCreate: field.disableOnCreate === true,
            labelWithRequired: required ? `${label} *` : label,
          };
        })
        .filter(Boolean);
    },
    filter() {
      return { DefID: this.defID, SecStatus: 0 };
    },
  },
  methods: {
    refresh(item){
      this.$emit('refresh',item);
    },
    isFieldDisabled(field, item) {
      if (!field || !item) return false;
      const isEdit = Number(item.DedID || 0) > 0;
      if (isEdit) return field.disableOnEdit;
      return field.disableOnCreate;
    },
    clearForm() {
      if (this.useCustomForm && this.normalizedCustomFields.length > 0) {
        const firstField = this.normalizedCustomFields[0];
        const refName = `Field_${firstField.key}`;
        const refControl = this.$refs[refName];
        const inputRef = Array.isArray(refControl) ? refControl[0] : refControl;
        if (inputRef && typeof inputRef.focus === "function") {
          inputRef.focus();
          return;
        }
      }

      if (this.$refs.DedDescription && typeof this.$refs.DedDescription.focus === "function") {
        this.$refs.DedDescription.focus();
      }
    },
    saveDed(item) {
      
      this.$fun.alert('¿Seguro de Guardar?','question').then((r)=>{
        if(r.value){
          item.DefID = this.defID;
      if (this.useCustomForm) {
        const requiredFields = this.normalizedCustomFields.filter((f) => f.required);
        const emptyField = requiredFields.find((f) => {
          const value = item[f.key];
          return value === null || value === undefined || String(value).trim().length === 0;
        });

        if (emptyField) {
          this.$fun.alert(`Registre ${emptyField.label}`, "warning");
          return;
        }
      } else {
        if (!item.DedDescription || item.DedDescription.length == 0) {
          this.$fun.alert("Registre descripción de valor", "warning");
          return;
        }
      }
      item.save();
      //emitir evento para refrescar listado padre
      console.log(item);
        }
      });
      
    },
    async onFileChange(file) {
      if (!file) {
        this.columns = [];
        return;
      }
      try {
        const reader = new FileReader();
        reader.onload = async (e) => {
          const buffer = e.target.result;
          const workbook = new ExcelJS.Workbook();
          await workbook.xlsx.load(buffer);
          const worksheet = workbook.worksheets[0];
          if (!worksheet) {
            this.$fun.alert("El Excel no tiene hojas", "warning");
            return;
          }

          const cols = [];
          const row = worksheet.getRow(1);
          const totalCols = Math.max(15, worksheet.columnCount || 0);
          for (let i = 1; i <= totalCols; i++) {
            const cellVal = row.getCell(i).value;
            const letter = this.getColumnLetter(i);
            const label = cellVal ? `${letter} - ${cellVal}` : `${letter} (Columna ${i})`;
            cols.push({ value: i, text: label });
          }
          this.columns = cols;
        };
        reader.readAsArrayBuffer(file);
      } catch (err) {
        console.error(err);
        this.$fun.alert("Error al leer el archivo Excel", "error");
      }
    },
    getColumnLetter(colIndex) {
      let temp, letter = '';
      while (colIndex > 0) {
        temp = (colIndex - 1) % 26;
        letter = String.fromCharCode(65 + temp) + letter;
        colIndex = (colIndex - temp - 1) / 26;
      }
      return letter;
    },
    closeUploadDialog() {
      this.dialogUpload = false;
      this.excelFile = null;
      this.columns = [];
      this.startRow = 2;
      this.valCol = null;
      this.descCol = null;
      this.abbrCol = null;
      this.helperCol = null;
      this.helper2Col = null;
      this.formatCol = null;
      this.loadingUpload = false;
    },
    processUpload() {
      if (!this.excelFile || !this.descCol) {
        this.$fun.alert("Seleccione el archivo y la columna de descripción", "warning");
        return;
      }

      this.$fun.alert("¿Seguro de importar este archivo Excel?", "question").then((r) => {
        if (r.value) {
          this.loadingUpload = true;
          const reader = new FileReader();
          reader.onload = () => {
            const arrayBuffer = reader.result;
            const bytes = new Uint8Array(arrayBuffer);
            let binary = "";
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            const base64 = window.btoa(binary);

            const payload = {
              DefID: this.defID,
              Base64Excel: base64,
              ValCol: this.valCol || -1,
              DescCol: this.descCol,
              AbbrCol: this.abbrCol || -1,
              HelperCol: this.helperCol || -1,
              Helper2Col: this.helper2Col || -1,
              FormatCol: this.formatCol || -1,
              StartRow: parseInt(this.startRow) || 2,
            };

            _sDefinitionDetail.uploadExcel(payload, this.$fun.getUserID())
              .then((response) => {
                this.loadingUpload = false;
                const msg = response.data.message || "Importación exitosa";
                this.$fun.alert(msg, "success");
                this.closeUploadDialog();
                this.refresh(null);
              })
              .catch((err) => {
                this.loadingUpload = false;
                const errorMsg = err.response?.data?.Message || err.message || "Error al subir";
                this.$fun.alert(errorMsg, "error");
              });
          };
          reader.readAsArrayBuffer(this.excelFile);
        }
      });
    },
  },
};
</script>
